import React from 'react';
import { Flex, HStack, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';
import PINSAISparkIcon from '../../PINSAISparkIcon';

import './styles.scss';

const HTabButton = ({
  isActive,
  onClick,
  title,
  idx,
  isLast,
  w,
  tabMarginRight = '40px',
  icon = null,
  cypressId = undefined
}) => (
  <Flex
    _hover={{ cursor: 'pointer' }}
    className={`horizontal-tab ${isActive && 'active'} ${icon && 'icon'}`}
    justifyContent="center"
    marginRight={isLast ? 0 : tabMarginRight}
    textStyle="bodyLg500"
    width={w || '100%'}
    zIndex={isActive ? 100 : 100 / (idx + 1)}
    onClick={onClick}
  >
    {icon
      ? (
        <HStack data-cy={cypressId} spacing={1}>
          <Text
            bgClip={isActive ? 'text' : ''}
            bgGradient={isActive ? colors.gradient.aiPrimary : ''}
            isTruncated={!isActive}
            pointerEvents="none"
            zIndex="150"
          >
            {title}
          </Text>
          <PINSAISparkIcon w="15px" />
        </HStack>
      ) : (
        <Text isTruncated data-cy={cypressId} pointerEvents="none" zIndex="150">
          {title}
        </Text>
      )}
  </Flex>
);

HTabButton.propTypes = {
  /** True if tab is currently selected. Determines styling */
  isActive: PropTypes.bool,
  /** Callback function for selecting a tab */
  onClick: PropTypes.func,
  /** Name of tab */
  title: PropTypes.string,
  /** Index of tab, used to determine z-index */
  idx: PropTypes.number,
  /** Determines styling for last item in tab list */
  isLast: PropTypes.bool,
  /** Width of tab */
  w: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Spacing between tabs.  Exlcudes last tab */
  tabMarginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Icon to display on tab */
  icon: PropTypes.element,
  /** Cypress id for tab */
  cypressId: PropTypes.string
};

export default HTabButton;
